interface LogoMetadata {
  src: string;
  alt: string;
  width: number;
  height: number;
}

interface FooterLogoMetadataObj {
  [key: string]: LogoMetadata;
}

export const FOOTER_LOGOS_METADATA: FooterLogoMetadataObj = Object.freeze({
  docusign: {
    src: require(`common/assets/images/customer-logos/docusign-logo.png`),
    alt: `DocuSign logo`,
    width: 101,
    height: 28,
  },
  ancestry: {
    src: require(`common/assets/images/customer-logos/ancestry-logo.png`),
    alt: `Ancestry logo`,
    width: 120,
    height: 27,
  },
  samsung: {
    src: require(`common/assets/images/customer-logos/samsung-logo.png`),
    alt: `Samsung logo`,
    width: 149,
    height: 23,
  },
  bmw: {
    src: require(`common/assets/images/customer-logos/bmw-logo.png`),
    alt: `BMW logo`,
    width: 40,
    height: 40,
  },
  homeaway: {
    src: require(`common/assets/images/customer-logos/homeaway-logo.png`),
    alt: `HomeAway logo`,
    width: 137,
    height: 28,
  },
  lemonade: {
    src: require(`common/assets/images/customer-logos/lemonade-logo.png`),
    alt: `Lemonade logo`,
    width: 97,
    height: 28,
  },
});
